import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    round
} from '../../../business-components/round/round'



export const processaRegistrosDefaultIniciaisHipotesesFinanceiras = (values) => {

    if (!values.percCapacidadePoupancaSugestaoAporteMensal) {

        values.percCapacidadePoupancaSugestaoAporteMensal = HARDCODE.percentual100
    }

}

export const setarAporteUnico = (values, valorAporteUnico) => {
     
    let setou = false

    values.aporteRetiradaAnual?.forEach( (linhaAporteRetiradaAnual, index) => {

        if (!setou) {

            if (linhaAporteRetiradaAnual.idade === values.idadeDataSimulacaoCliente && !linhaAporteRetiradaAnual.idadeFinal) {

                linhaAporteRetiradaAnual.aporteAnual =
                    (linhaAporteRetiradaAnual.aporteAnual
                        ?    
                            round(linhaAporteRetiradaAnual.aporteAnual, 2)
                        :
                            0
                    ) + valorAporteUnico

                setou = true
            }
        }
    })

    if (!setou) {

        values.aporteRetiradaAnual?.forEach( (linhaAporteRetiradaAnual, index) => {

            if (!setou) {

                if (!linhaAporteRetiradaAnual.idade && !linhaAporteRetiradaAnual.idadeFinal) {

                    linhaAporteRetiradaAnual.idade = values.idadeDataSimulacaoCliente
                    linhaAporteRetiradaAnual.aporteAnual =
                        (linhaAporteRetiradaAnual.aporteAnual
                            ?    
                                round(linhaAporteRetiradaAnual.aporteAnual, 2)
                            :
                                0
                        ) + valorAporteUnico

                    setou = true
                }
            }
        })
    }

    if (!setou) {
        
        values.aporteRetiradaAnual.push({
            idade: values.idadeDataSimulacaoCliente,
            aporteAnual: valorAporteUnico,
        })
    }
}